import * as React from 'react';
import { VariableSizeList } from 'react-window';

export const useResetCache = (layout: string) => {
  const ref = React.useRef<VariableSizeList>(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [layout]);
  return ref;
};
